require('./reimburseInvestmentFunds.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ actions
const reimburseInvestmentActions = require('actions/reimburseInvestment');
const printerActions = require('actions/contactCenter/printer');
const brokerStocksByTypeActions = require('actions/brokerStocksByType');
const brokerProductAdvancedSearchActions = require('actions/brokerProductAdvancedSearch');

// @ commons
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKMessage } = require('commonsComponents/OKMessage');
const { ContentBox } = require('commonsComponents/contentBox');
const OKModal = require('components/commons/OKModal/OKModal');
// @ components
const ReimburseInvestmentHeader = require('components/hireInvestmentFunds/reimburseInvestmentHeader/reimburseInvestmentHeader');
const ReimburseInvestment = require('components/hireInvestmentFunds/reimburseInvestment/reimburseInvestment');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const MorningStarCopyright = require('components/commons/morningStarCopyright/morningStarCopyright');
// @constants
const { MYPROFILE_BROKER_EXPLORE_URL, MYPROFILE_BROKER_URL } = require('constants/index');

class ReimburseInvestmentFunds extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: true
        };
        this.handleToggleModal = this.handleToggleModal.bind(this);

        this.handleFinish = this.handleFinish.bind(this);
        this.onSetAmountChange = this.onSetAmountChange.bind(this);
        this.onSetParticipationChange = this.onSetParticipationChange.bind(this);
    }

    componentWillMount() {
        const {
            getMorningStarScreener,
            getReimburseNewOrder,
            history,
            immMyInvestments,
            match: { params: { fundId, contractNumber } }
        } = this.props;
        const immMyInvestmentsFunds = immMyInvestments.getIn(['products', 'funds', 'stocks']);
        const immCurrentFund = immMyInvestmentsFunds.find(
            immFund => immFund.get('contractNumber') === contractNumber || immFund.get('secID') === contractNumber
        );
        if (immCurrentFund) {
            const currentFundContractNumber = immCurrentFund.get('contractNumber');
            getMorningStarScreener(fundId);
            getReimburseNewOrder(fundId, currentFundContractNumber);
            if (!immMyInvestments.get('fetchSuccess') && !immMyInvestments.get('isFetching') && !immMyInvestments.get('errorReceived')) {
                this.props.getStocksByType();
            }
        }
        else {
            history.push(`/myprofile/broker/general`);
        }
    }

    componentWillUnmount() {
        const { reset, resetPrintedIndicators, clearSearchResults } = this.props
        reset();
        clearSearchResults();
        if (__CONTACT_CENTER__) resetPrintedIndicators();
    }

    handleToggleModal() {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    onSetAmountChange(value) {
        this.props.setAmount(value);
    }

    onSetParticipationChange(value, amount) {
        this.props.setParticipation(value, amount);
    }

    buildErrorScreen() {
        return (
            <ContentBox id="brokerInvestmentSpecialistError">
                <div className="reimburse-investment-funds__icon-error">
                    <i className="callmeback__icon-error-icon icon-error" />
                </div>
                <p className="reimburse-investment-funds__icon-success-label">
                    <FormattedText value="callmeback-errorMessageTitle" />
                </p>
                <p className="reimburse-investment-funds__error-message">
                    <FormattedText value="callmeback-errorMessageSubtitle" />
                </p>
            </ContentBox>
        );
    }

    buildHeader() {
        const { match: { params: { fundId } } } = this.props;

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-reimburseInvestmentFunds'),
                url: `/myprofile/reimburseInvestment/${fundId}`
            }
        ];

        return (
            <OKCover size="medium" section="broker">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={getFinalTitle('breadcrumb-reimburseInvestmentFunds')}
                >
                    <OKButton
                        inverse={true}
                        modifier="ghost"
                        to={MYPROFILE_BROKER_EXPLORE_URL}
                    >
                        <FormattedText value="broker-goToAdvancedSearch" />
                    </OKButton>
                </OKHeaderSubPage>
            </OKCover>
        );
    }

    handleCancel() {
        this.props.history.push('/myprofile/broker');
    }

    handleFinish() {
        const { history, immReimburseInvestment } = this.props;
        this.props.reimburseInvestmentFund(immReimburseInvestment, history);
    }

    render() {
        const {
            immMyInvestments,
            setVisibleStep,
            validateStep,
            setWillCancel,
            handleChangeType,
            immReimburseInvestment,
            immBrokerFundLegalDocument,
            immBrokerProductAdvancedSearch,
            reimburseInvestmentFund,
            getReimburseExAntDetails,
            immFlagBasedFeatures,
            match: { params: { contractNumber, fundId } }
        } = this.props;
        const header = this.buildHeader();
        const notFound = immReimburseInvestment.get('notFound');
        const fundData = immReimburseInvestment.getIn(['steps', 0, 'reimburseInvestment']);
        const fetchingError = immReimburseInvestment.get('newOrderError') || immReimburseInvestment.get('medysifError');
        const fetchedAdvancedSearch = immBrokerProductAdvancedSearch.get('fetched');
        let content;

        if (fundData && fetchedAdvancedSearch && !fetchingError) {
            const immInvestmentFund = immMyInvestments.getIn(['products', 'funds', 'stocks']).find(immFund =>
                immFund.get('numerodecontrato') === contractNumber && immFund.get('secID') === fundData.get('fundId')
            );
            const balance = immInvestmentFund
                ? { amount: immInvestmentFund.get('totalValue'), currency: immInvestmentFund.get('totalValueCurrency') }
                : { amount: 0, currency: 'EUR' }

            const modalText = formatText('brokerInternalTransferFundsPreStep-brokerInternalTransferFundsPreStep_modalDescription');
            const modalButtonText = formatText('brokerInternalTransferFundsPreStep-brokerInternalTransferFundsPreStep_modalButtonText');
            const modal = !!immInvestmentFund.get('isBlockedByRobo') ? (
                <OKModal
                    content={modalText}
                    isOpen={this.state.showModal}
                    onCloseCallback={this.handleToggleModal}
                    onPrimaryButtonClick={this.handleToggleModal}
                    footerType="action"
                    primaryButtonText={modalButtonText}
                />
            ) : null;
            const isNotLastStep = immReimburseInvestment && !immReimburseInvestment.get('submitSuccessful');
            const infoMessage = isNotLastStep ? (
                <OKMessage type="informative">
                    <FormattedText
                        value="brokerReimburseInvestmentStep1-info"
                        injectedStrings={[formatText('emails-investments')]}
                    />
                </OKMessage>
            ) : null;

            content = (
                <div className="reimburse-investment-funds">
                    {header}
                    {modal}
                    <div className="reimburse-investment-funds__body">
                        <div className="row no-outside-gutter">
                            <ReimburseInvestmentHeader
                                immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch}
                                immReimburseInvestment={immReimburseInvestment}
                                modifier="etfs"
                                balance={balance}
                                immInvestmentFund={immInvestmentFund}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                            />
                            <div className="reimburse-investment-funds__message">
                                {infoMessage}
                            </div>
                            <ReimburseInvestment
                                disableButton={immInvestmentFund.get('isBlockedByRobo')}
                                validateStep={validateStep}
                                setVisibleStep={setVisibleStep}
                                setWillCancel={setWillCancel}
                                onCancel={() => this.handleCancel()}
                                onFinish={this.handleFinish}
                                handleSetAmount={this.onSetAmountChange}
                                handleSetParticipation={this.onSetParticipationChange}
                                handleChangeType={handleChangeType}
                                immMyInvestments={immMyInvestments}
                                immReimburseInvestment={immReimburseInvestment}
                                immBrokerFundLegalDocument={immBrokerFundLegalDocument}
                                immInvestmentFund={immInvestmentFund}
                                balance={balance}
                                reimburseInvestmentFund={reimburseInvestmentFund}
                                getReimburseExAntDetails={getReimburseExAntDetails}
                                contractNumber={contractNumber}
                                fundId={fundId}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                            />
                        </div>
                    </div>
                    <MorningStarCopyright fromFunds={true} />
                </div>
            );
        } else if (fetchingError) {
            content = this.buildErrorScreen();
        }
        else if (notFound) {
            content = (
                <div className="reimburse-investment-funds__empty-state">
                    <ContentBox>
                        <div className="reimburse-investment-funds__empty-state-content">
                            <div className="row no-outside-gutter">
                                <EmptyState primaryText={'No se han encontrado datos del fondo'} iconType="nointernet-banking" />
                            </div>
                        </div>
                    </ContentBox>
                </div>
            );
        } else {
            content = <LoadingSection />;
        }
        return content;
    }
}

ReimburseInvestmentFunds.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    reimburseInvestmentFund: PropTypes.func.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    getReimburseNewOrder: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setAmount: PropTypes.func.isRequired,
    immBrokerFundLegalDocument: PropTypes.object.isRequired,
    getMorningStarScreener: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    handleChangeType: PropTypes.func.isRequired,
    immReimburseInvestment: PropTypes.object.isRequired,
    reset: PropTypes.func,
    clearSearchResults: PropTypes.func.isRequired,
    getReimburseExAntDetails: PropTypes.func.isRequired,

};

module.exports.constructor = ReimburseInvestmentFunds;

module.exports.ReimburseInvestmentFunds = connect(
    state => ({
        immBrokerProductAdvancedSearch: state.brokerProductAdvancedSearch,
        immMyInvestments: state.brokerMyInvestments,
        immInvestmentFunds: state.investmentFunds,
        immReimburseInvestment: state.reimburseInvestment,
        immBrokerFundLegalDocument: state.brokerFundLegalDocument,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        validateStep: reimburseInvestmentActions.validateStep,
        resetPrintedIndicators: printerActions.resetPrintedIndicators,
        setVisibleStep: reimburseInvestmentActions.setVisibleStep,
        setWillCancel: reimburseInvestmentActions.setWillCancel,
        getStocksByType: brokerStocksByTypeActions.getStocksByType,
        reimburseInvestmentFund: reimburseInvestmentActions.reimburseInvestmentFund,
        getReimburseNewOrder: reimburseInvestmentActions.getReimburseNewOrder,
        getMorningStarScreener: reimburseInvestmentActions.getMorningStarScreener,
        setAmount: reimburseInvestmentActions.setAmount,
        setParticipation:  reimburseInvestmentActions.setParticipation,
        setWillLeave: reimburseInvestmentActions.setWillLeave,
        onSetAmountChange: reimburseInvestmentActions.setAmount,
        handleChangeType: reimburseInvestmentActions.changeType,
        getReimburseExAntDetails: reimburseInvestmentActions.getReimburseExAntDetails,
        reset: reimburseInvestmentActions.reset,
        clearSearchResults: brokerProductAdvancedSearchActions.clearResults,

    }
)(withRouter(ReimburseInvestmentFunds));
